// Light theme color palette
export const lightColors = {
  primary: '#999',
  secondary: '#333',
  background: '#fff',
  surface: '#f5f5f5',
  navbar: '#999', // Mid-tone grey for the main menu/navbar
  primaryLight: '#adadad', // Light variant for backgrounds and containers
  text: {
    primary: '#000',
    secondary: '#999',
    disabled: '#ccc',
    // Add white text for AppBar/navbar content
    navbar: '#fff',
  },
  accent: '#0000ff',
  error: '#ff0000',
  warning: '#ff9800',
  info: '#2196f3',
  success: '#4caf50',
  divider: '#e0e0e0',
  // CSS custom properties mapping
  cssVariables: {
    '--default-background': '#fff',
    '--secondary-background': '#333',
    '--primary-light': '#adadad',
    '--primary-text': '#000',
    '--secondary-text': '#999',
    '--drawer-width': '240px',
    '--default-radius': '0.3rem',
  },
} as const;
